import { useEffect, useState } from 'react';
import { useQuery } from '../common';

export function useSignupFlow() {
  const [signupFlow, setSignupFlow] = useState(false);
  const query = useQuery();

  useEffect(() => {
    // Get state from URL
    const stateFromUrl = query.get('state');
    
    if (stateFromUrl) {
      // Check if it's a signup flow (doesn't start with 'nameSync_' or 'nameChange_')
      const isSignup = stateFromUrl === '123456789012345678901234567890';
      // && !stateFromUrl.startsWith('nameSync_') && !stateFromUrl.startsWith('nameChange_');
      setSignupFlow(isSignup);
    }
  }, [query]);

  return signupFlow;
}
